﻿

// ------------------------------------------------------------------------- //
// #EDIT-VALUE
// ------------------------------------------------------------------------- //


window.farmday = window.farmday || {};
farmday.modules = farmday.modules || {};


farmday.modules.edit = (function () {
    var priv = {};


    /**
     * Private initialization method
     */
    priv.init = function () {

        /**
         * Click on edit button
         */
        $(document).on("click", ".js-edit", function (e) {
            var button = $(this);
            var input = $(this).data("input");
            var label = $(this).data("label");
            var value = $(this).data("value");

            var isEditable = priv.isEditable(input);

            if (isEditable) {
                priv.save(input, value);
                priv.disableEdit(button, input, label);
            } else {
                priv.enableEdit(button, input, label);
            }
        });

        /**
         * Keypress in edit value field
         */
        $(document).on("keydown", ".js-edit-value", function (e) {
            var input = this;
            var button = $(this).data("button");
            var label = $(this).data("label");
            var value = $(this).data("value");

            if (e.which == 13) {
                // Enter key
                priv.save(input, value);
                priv.disableEdit(button, input, label);
            } else if (e.which == 27) {
                // Escape key
                priv.disableEdit(button, input, label);
            }
        });
    };


    /**
     * Enable edit
     */
    priv.enableEdit = function (button, input, label) {
        var button = $(button);
        var input = $(input);
        var label = $(label);

        button.addClass("is-active");
        label.removeClass("is-active");
        input.addClass("is-active");

        var tmpStr = input.val();
        input.val("");
        input.val(tmpStr);
        input.focus().select();
    };


    /**
     * Save value
     */
    priv.save = function (input, value) {
        var input = $(input);
        var value = $(value);

        value.html(input.val());
    };


    /**
     * Disable edit
     */
    priv.disableEdit = function (button, input, label) {
        var button = $(button);
        var input = $(input);
        var label = $(label);

        button.removeClass("is-active");
        input.removeClass("is-active");
        label.addClass("is-active");
    };


    /**
     * Check if element is editable
     */
    priv.isEditable = function (element) {
        return $(element).hasClass("is-active");
    };


    // Initialize module
    $(function () {
        priv.init();
    });

})();
